// Global utility functions

class CartDrawer {
  constructor() {
    this.cart = null;
    this.init();
  }

  async init() {
    await this.getCart();
    this.updateCartCount();
  }

  async getCart() {
    try {
      const response = await fetch('/cart.js');
      this.cart = await response.json();
      return this.cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  }

  async addItem(id, quantity = 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.getCart();
        this.updateCartCount();
        return await response.json();
      } else {
        const error = await response.json();
        throw new Error(error.description || 'Failed to add item to cart');
      }
    } catch (error) {
      console.error('Error adding item:', error);
      alert(error.message);
    }
  }

  async updateItem(line, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      });

      if (response.ok) {
        await this.getCart();
        this.updateCartCount();
        return await response.json();
      }
    } catch (error) {
      console.error('Error updating item:', error);
    }
  }

  updateCartCount() {
    const countElement = document.getElementById('cart-count');
    if (countElement && this.cart) {
      countElement.textContent = this.cart.item_count;
      if (this.cart.item_count === 0) {
        countElement.style.display = 'none';
      } else {
        countElement.style.display = 'flex';
      }
    }
  }
}

// Initialize cart
const cartDrawer = new CartDrawer();

// Product form handling
document.addEventListener('DOMContentLoaded', function() {
  const productForm = document.getElementById('product-form');
  
  if (productForm) {
    productForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const formData = new FormData(productForm);
      const variantId = formData.get('id');
      const submitButton = productForm.querySelector('button[type="submit"]');
      
      submitButton.classList.add('loading');
      submitButton.disabled = true;
      
      try {
        await cartDrawer.addItem(variantId, 1);
        submitButton.textContent = 'Added!';
        
        setTimeout(() => {
          submitButton.textContent = 'Add to Cart';
          submitButton.classList.remove('loading');
          submitButton.disabled = false;
        }, 2000);
      } catch (error) {
        submitButton.classList.remove('loading');
        submitButton.disabled = false;
      }
    });
  }
});

// Mobile menu toggle
document.addEventListener('DOMContentLoaded', function() {
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  const mobileClose = document.getElementById('mobile-menu-close');
  
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (mobileClose && mobileMenu) {
    mobileClose.addEventListener('click', function() {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    });
  }
});

// Search modal
document.addEventListener('DOMContentLoaded', function() {
  const searchIcon = document.querySelector('a[href*="search"]');
  
  if (searchIcon) {
    searchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      openSearchModal();
    });
  }
});

function openSearchModal() {
  let modal = document.getElementById('search-modal');
  
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'search-modal';
    modal.className = 'search-modal';
    modal.innerHTML = `
      <button class="search-modal__close" onclick="closeSearchModal()">&times;</button>
      <div class="search-modal__content">
        <form action="/search" method="get">
          <input type="search" 
                 name="q" 
                 placeholder="Search..." 
                 class="search-modal__input"
                 autofocus>
        </form>
      </div>
    `;
    document.body.appendChild(modal);
  }
  
  modal.classList.add('active');
  modal.querySelector('input').focus();
}

function closeSearchModal() {
  const modal = document.getElementById('search-modal');
  if (modal) {
    modal.classList.remove('active');
  }
}

// Close search modal on escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeSearchModal();
  }
});

// Image lazy loading
if ('loading' in HTMLImageElement.prototype) {
  const images = document.querySelectorAll('img[loading="lazy"]');
  images.forEach(img => {
    img.src = img.dataset.src || img.src;
  });
} else {
  // Fallback for browsers that don't support lazy loading
  const script = document.createElement('script');
  script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
  document.body.appendChild(script);
}

